module.exports = __webpack_public_path__ + "static/img/dummycourses.c3b8ea9f.gif";